import React from 'react'
import Popup from './Popup'
import NewsletterSignupForm from './NewsletterSignupForm'
import { makeControlledModal } from 'src/decorators/ModalController'

interface MarketingPopupModalProps {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  settings: {
    popupFrequency: string
    enableMarketingPopup: boolean
    triggerType: string
    timeDelayTrigger: number
    pageScrollTrigger: number
    enableNewsletterSignup: boolean
    popupImage: string | boolean
    closeButtonText: string
    bodyText: string
    headerText: string
    newsletterHeaderText: string
    showPopupImage: boolean
    requestSubscriberName: boolean
  }
  previewMode: boolean
}

const MarketingPopupModal = ({
  modal,
  settings,
  previewMode,
  ...props
}: MarketingPopupModalProps): JSX.Element => {
  const {
    headerText,
    bodyText,
    closeButtonText,
    popupImage,
    enableNewsletterSignup,
    showPopupImage,
    requestSubscriberName
  } = settings

  return (
    <Popup
      {...props}
      {...modal}
      body={
        enableNewsletterSignup && (
          <NewsletterSignupForm
            previewMode={previewMode}
            requestSubscriberName={requestSubscriberName}
          />
        )
      }
      popupImage={showPopupImage && popupImage}
      headerText={headerText}
      bodyText={bodyText}
      closeButtonText={closeButtonText}
    />
  )
}

export default makeControlledModal(MarketingPopupModal, 'MarketingPopupModal')
